<template>
  <ContentWrapper v-if="getData" class="overflow-hidden" :setBackground="{type: 'bgcolor', value: '#eaeff2'}">
    <h2 class="font-bold text-2xl xl:text-3xl mb-6 text-center">永續人物專訪</h2>
    <div class="w-11/12 md:w-full m-auto">
      <BtnetSlider :sliderData="getData" />
    </div>
  </ContentWrapper>
</template>

<script>
import ContentWrapper from './models/ContentWrapper'
import BtnetSlider from './models/BtnetSlider'

export default {
  name: 'Character',
  components: {
    ContentWrapper,
    BtnetSlider
  },
  computed: {
    getData() {
      return this.$store.state.indexData.character;
    }
  }
}
</script>
